import { render, staticRenderFns } from "./informe-abonos-cobros.vue?vue&type=template&id=63dd7174&scoped=true"
import script from "./informe-abonos-cobros.vue?vue&type=script&lang=js"
export * from "./informe-abonos-cobros.vue?vue&type=script&lang=js"
import style0 from "./informe-abonos-cobros.vue?vue&type=style&index=0&id=63dd7174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd7174",
  null
  
)

export default component.exports